const createFileList = attachments => {
  return attachments?.map(e => ({ id: e?.id, name: e?.name, title: e?.title, url: e?.src || e?.url }))
}

const mediaDataTransformer = response => {
  let mediaItems = []
  const noFloorPlans = Object.keys(response?.floorPlan || {}).length == 0;
  if (response?.Images?.hasImages && !noFloorPlans ) {
    response.Images["unitFloorPlans"] = [response?.floorPlan];}
   else if (!response?.Images?.hasImages && !noFloorPlans ){
    response.Images = {"hasImages":true,"imagesCount":1,"unitFloorPlans": [response?.floorPlan] };
  }  
  Object.entries(response?.Images).forEach(([section, files]) => {
    if (Array.isArray(files)) {
      mediaItems = [...mediaItems, ...createFileList(files)?.map(e => ({ ...e, section, checkedState: false }))]
    } else if (typeof files === "object") {
      Object.entries(files).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          mediaItems = [
            ...mediaItems,
            ...createFileList(value)?.map(e => ({ ...e, section, mediaType: key, checkedState: false })),
          ]
        }
      })
    }
  })
  response = { ...response, mediaItems }
  return response
}

export default mediaDataTransformer
